import React, { useRef } from 'react';
import PropTypes from 'prop-types';

// 이미지 PC/M 분기
function CouponBanner({ banner }) {
  const couponBannerRef = useRef(null);
  const {
    linkType,
    pcImageUrl,
    appImageUrl,
    imageAltText,
    landingInfo,
  } = banner;

  // 배너에 linkType이 none 이면 그리지 않는다.
  if (linkType === 'NONE' || !pcImageUrl || !appImageUrl) {
    return null;
  }

  const sImageUrl = TMON.bMobile ? appImageUrl : pcImageUrl;

  const handleClick = e => {
    e.preventDefault();
    const url = landingInfo;
    if (!url) return;

    TMON.sendLog(null, [
      couponBannerRef.current,
      null,
      {
        'tl:area': 'DDCB',
        'tl:dimension': `main_deal_srl:${TMON.htStaticData.htDealInfo.dealNo}`,
      },
    ]);

    if (TMON.sDevice === 'PW' || TMON.sDevice === 'MW') {
      window.open(url, '_blank');
    } else {
      const title = imageAltText; // callApp 타이틀은 imageAltText 값으로 만든다.
      TMON.app.callApp('webview', 'showView', title, url, true);
    }
  };

  return (
    <a
      onClick={handleClick}
      className="link_banner"
      rel="noopener noreferrer"
      ref={couponBannerRef}
    >
      <img src={sImageUrl} alt={imageAltText || null} />
    </a>
  );
}

CouponBanner.propTypes = {
  banner: PropTypes.shape({}),
};

export default CouponBanner;
